// حول — the institution's details, the developer's, and the rights
// notice, shown on the profile page and under the login card. The same
// file lives in the manager panel (manager-panel/src/app/about.js) —
// keep them equal. Contact details match the public site.

export const SCHOOL_INFO = {
  name: 'مؤسسة المتميزون التعليمية',
  short: 'المتميزون',
  logo: '/images/logo-512.webp',
  stages: 'الروضة، الابتدائية، الإعدادية، والثانوية بفرعيها العلمي والأدبي',
  address: 'أعزاز، نهاية شارع العصيانة، خلف منظمة شفق — ريف حلب الشمالي',
  map: 'https://www.google.com/maps/search/?api=1&query=%D9%85%D8%A4%D8%B3%D8%B3%D8%A9%20%D8%A7%D9%84%D9%85%D8%AA%D9%85%D9%8A%D8%B2%D9%88%D9%86%20%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A%D8%A9%20%D8%A3%D8%B9%D8%B2%D8%A7%D8%B2',
  website: 'https://mtzedu.com',
  phones: [
    { label: '+90 555 888 83 27', tel: '+905558888327' },
    { label: '+963 951 844 532', tel: '+963951844532' },
    { label: '+90 552 755 75 46', tel: '+905527557546' },
  ],
  whatsapp: 'https://wa.me/905558888327',
  facebook: 'https://www.facebook.com/Am.Co.Ed/',
  instagram: 'https://www.instagram.com/almutmayzoon2020/',
};

export const DEVELOPER = {
  name: 'م. خالد حميدي',
  role: 'تصميم وتطوير النظام',
  website: 'https://khaledhamidi.com',
  websiteLabel: 'khaledhamidi.com',
  phone: { label: '+90 553 955 25 52', tel: '+905539552552' },
  whatsapp: 'https://wa.me/905539552552',
};

export const RIGHTS_YEAR = Math.max(2026, new Date().getFullYear());

export const RIGHTS = {
  school: `© ${RIGHTS_YEAR} ${SCHOOL_INFO.name}. اسم المؤسسة وشعارها وبياناتها وبيانات طلابها وكوادرها ملكٌ للمؤسسة، جميع الحقوق محفوظة.`,
  developer: `تصميم النظام وبرمجته وواجهاته وملفاته وأصواته وأيقوناته وصوره من إعداد ${DEVELOPER.name}، جميع الحقوق محفوظة.`,
  noCopy: 'يُمنع نسخ أي جزء من النظام أو إعادة استخدامه أو نشره دون إذن خطّي مسبق.',
  thirdParty: 'المكتبات مفتوحة المصدر المستخدمة في النظام تبقى لأصحابها وفق تراخيصها.',
};

/** One short line for footers. */
export const CREDIT_LINE = `© ${RIGHTS_YEAR} ${SCHOOL_INFO.short} · تصميم وتطوير ${DEVELOPER.name}`;

/** "2026-2027" → "2026–2027" (reads as a range, not a subtraction). */
export const yearLabel = (title) => String(title || '').replace('-', '–');
